module.exports = __webpack_public_path__ + "8f11fa9a3737e2e4c509838d4ec24e3e.png";